import React from 'react';
import Icon from '../AppIcon';

const StatusIndicator = ({ status, label, size = 'default', showIcon = true, className = '' }) => {
  const statusConfig = {
    pending: {
      color: 'text-warning',
      bgColor: 'bg-warning/10',
      borderColor: 'border-warning/20',
      icon: 'Clock',
      label: 'En attente'
    },
    'in-transit': {
      color: 'text-primary',
      bgColor: 'bg-primary/10',
      borderColor: 'border-primary/20',
      icon: 'Truck',
      label: 'En transit',
      animate: 'animate-pulse-subtle'
    },
    delivered: {
      color: 'text-success',
      bgColor: 'bg-success/10',
      borderColor: 'border-success/20',
      icon: 'CheckCircle',
      label: 'Livré',
      animate: 'animate-bounce-check'
    },
    delayed: {
      color: 'text-warning',
      bgColor: 'bg-warning/10',
      borderColor: 'border-warning/20',
      icon: 'AlertTriangle',
      label: 'Retardé'
    },
    cancelled: {
      color: 'text-error',
      bgColor: 'bg-error/10',
      borderColor: 'border-error/20',
      icon: 'XCircle',
      label: 'Annulé'
    },
    processing: {
      color: 'text-accent',
      bgColor: 'bg-accent/10',
      borderColor: 'border-accent/20',
      icon: 'Package',
      label: 'En traitement'
    }
  };

  const sizeConfig = {
    sm: {
      padding: 'px-2 py-1',
      text: 'text-xs',
      iconSize: 14
    },
    default: {
      padding: 'px-3 py-1.5',
      text: 'text-sm',
      iconSize: 16
    },
    lg: {
      padding: 'px-4 py-2',
      text: 'text-base',
      iconSize: 18
    }
  };

  const config = statusConfig?.[status] || statusConfig?.pending;
  const sizeStyle = sizeConfig?.[size];
  const displayLabel = label || config?.label;

  return (
    <div
      className={`
        inline-flex items-center space-x-2 rounded-md border
        ${config?.bgColor} ${config?.borderColor} ${sizeStyle?.padding}
        ${config?.animate || ''}
        transition-smooth
        ${className}
      `}
    >
      {showIcon && (
        <Icon
          name={config?.icon}
          size={sizeStyle?.iconSize}
          className={config?.color}
        />
      )}
      <span className={`${config?.color} ${sizeStyle?.text} font-medium`}>
        {displayLabel}
      </span>
    </div>
  );
};

export default StatusIndicator;